import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        _setup.DialogBottomSheet,
        {
          attrs: {
            "is-visible": _setup.isVisible,
            width: _setup.isMobile ? "100%" : "360px",
          },
          on: {
            "dialog-bottom-sheet:change-visible": function ($event) {
              _setup.isVisible = $event
            },
          },
        },
        [
          _c(
            VCard,
            {
              staticClass: "doctor-contacts",
              class: { "doctor-contacts_mobile": _setup.isMobile },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  class: _setup.isMobile ? "px-4 pt-6" : "pa-2",
                },
                [
                  !_setup.isMobile
                    ? _c(
                        VBtn,
                        {
                          staticClass: "mr-4",
                          attrs: {
                            icon: "",
                            text: "",
                            color: "icon-secondary",
                            "data-qa": "base_modal_close",
                          },
                          on: {
                            click: function ($event) {
                              _setup.isVisible = false
                            },
                          },
                        },
                        [
                          _c(VIcon, [
                            _vm._v(
                              "\n            ui-icon-close-not-a-circle\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-h6 text--text" }, [
                    _vm._v(
                      "\n          " + _vm._s(_setup.title) + "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              !_setup.isMobile ? _c(VDivider) : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "doctor-contacts__body" },
                [
                  _setup.isLoading
                    ? _c(_setup.DoctorContactsSkeleton, {
                        staticClass: "pt-3 pb-4",
                      })
                    : [
                        _c(_setup.DoctorContactsList, {
                          staticClass: "pt-4 pb-2",
                          attrs: {
                            doctor: _setup.doctor,
                            "contacts-list": _setup.contactsList,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-caption icon-secondary--text px-4 pb-6",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_setup.description) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_setup.useAuthMt
        ? _c(_setup.UserAuthorization, {
            attrs: {
              "is-visible": _setup.isVisibleAuth,
              persistent: false,
              "is-render-in-modal": "",
            },
            on: {
              "modal:update-visible": function ($event) {
                _setup.isVisibleAuth = $event
              },
              "authorization:confirmed": _setup.handleAuthConfirm,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }